import React from "react";
import { string, arrayOf, object, any } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { ComponentsSlider } from "../ComponentsSlider";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../sharedComponents/Link";
import { cloudinaryImageToSrcUrlAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
import { Cell, Row } from "../Grid";
import * as styles from "./BrandsCarousel.module.scss";

const Card = ({ logo, title, link }) => (
	<div className={styles.brandCard}>
		{logo && (
			<div>
				<img src={logo} alt={title && title} />
			</div>
		)}
		{title && <span className={styles.brandName}>{title}</span>}
		{link && (
			<Link className={styles.brandCardLink} to={link}>
				<span className="sr-only">{title}</span>
			</Link>
		)}
	</div>
);

const Slide = ({ entries }) => (
	<Row cols="brand">
		{entries &&
			entries.map(entry => (
				<Cell key={entry.id}>
					<div className={styles.brandsCarouselItem}>
						<Card
							logo={cloudinaryImageToSrcUrlAdapter(entry?.logo?.[0])}
							title={entry.title}
							link={`/${entry?.node_locale?.substr(0, 2)}/hotel/hotel-brands/${
								entry?.slug !== null ? entry?.slug : ""
							}`}
						/>
					</div>
				</Cell>
			))}
	</Row>
);

const BrandsCarousel = ({ slides }) => (
	<div className={styles.brandsCarouselContainer}>
		<ComponentsSlider
			slidesPerPage={1}
			navigation="desktopOnly"
			paging={true}
			slides={slides.map((slide, index) => ({
				id: index + 1,
				view: <Slide entries={slide} />,
			}))}
		/>
	</div>
);

BrandsCarousel.propTypes = {
	slides: any.isRequired,
};

Slide.propTypes = {
	entries: arrayOf(object).isRequired,
};

Card.propTypes = {
	logo: string,
	link: string,
	title: string.isRequired,
};

Card.defaultProps = {
	logo: null,
	link: null,
};

export default BrandsCarousel;
export { BrandsCarousel };
